// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"678f9854","239":"5ff7edd4","453":"3c02d46b","455":"97a0fa30"}[chunkId] + ".chunk.js";
};